import React, { useContext } from 'react';
import logo from "./logo_nav.png"
import { useNavigate } from "react-router-dom";
import { ProfileContext } from '../App';

function MiniHeaderComponent() {
    const profileContext = useContext(ProfileContext)

    const inProgressConfig = () => {
        for (let i = 1; i <= profileContext.length; i++) {
            if (profileContext[i] !== 1) {
                return true
            }
        }
        return false
    }

    // let navigate = useNavigate()

    const handleRedirect = () => {
        // window.location.href = "https://www.kytopen.com/"
        if (!inProgressConfig()) {
            if (window.confirm("You currently have a waveform profile that is in progress. If you continue to the home page your progress will be lost. Do you wish to continue?") === true) {
                window.location.reload(false)
            } else {
                return
            }
        }
    }
    return (
            <img src={logo} className="mini__logo" alt="miniLogo" onClick={handleRedirect} />
    )
}

export default MiniHeaderComponent